var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _g2, _path24, _path25, _g3, _path26, _path27, _g4, _path28, _path29, _g5, _path30, _path31, _g6, _path32, _path33, _g7, _path34, _path35, _g8, _path36, _path37, _g9, _path38, _path39, _g0, _path40, _path41, _g1, _path42, _path43, _g10, _path44, _path45, _g11, _path46, _path47, _g12, _path48, _path49, _g13, _path50, _path51, _g14, _path52, _path53, _g15, _path54, _path55, _g16, _path56, _path57, _g17, _path58, _path59, _g18, _path60, _path61, _g19, _path62, _path63, _g20, _path64, _path65, _g21, _path66, _path67, _g22, _path68, _path69, _g23, _path70, _path71, _g24, _path72, _path73, _g25, _path74, _path75, _g26, _path76, _path77, _g27, _path78, _path79, _g28, _path80, _path81, _g29, _path82, _path83, _g30, _path84, _path85, _g31, _path86, _path87, _g32, _path88, _path89, _g33, _path90, _path91, _g34, _path92, _path93, _g35, _path94, _path95, _g36, _path96, _path97, _g37, _path98, _path99, _g38, _path100, _path101, _g39, _path102, _path103, _g40, _path104, _path105, _g41, _path106, _path107, _g42, _path108, _path109, _g43, _path110, _path111, _g44, _path112, _path113, _g45, _path114, _path115, _g46, _path116, _path117, _g47, _path118, _path119, _g48, _path120, _path121, _g49, _path122, _path123, _g50, _path124, _path125, _g51, _path126, _path127, _g52, _path128, _path129, _g53, _path130, _path131, _g54, _path132, _path133, _g55, _path134, _path135, _g56, _path136, _path137, _g57, _path138, _path139, _g58, _path140, _path141, _g59, _path142, _path143, _g60, _path144, _path145, _g61, _path146, _path147, _g62, _path148, _path149, _g63, _path150, _path151, _g64, _path152, _path153, _g65, _path154, _path155, _g66, _path156, _path157, _g67, _path158, _path159, _g68, _path160, _path161, _g69, _path162, _path163, _g70, _path164, _path165, _g71, _path166, _path167, _g72, _path168, _path169, _g73, _path170, _path171, _g74, _path172, _path173, _g75, _path174, _path175, _g76, _path176, _path177, _g77, _path178, _path179, _g78, _path180, _path181, _g79, _path182, _path183, _g80, _path184, _path185, _g81, _path186, _path187, _g82, _path188, _path189, _g83, _path190, _path191, _g84, _path192, _path193, _g85, _path194, _path195, _g86, _path196, _path197, _g87, _path198, _path199, _g88, _path200, _path201, _g89, _path202, _path203, _g90, _path204, _path205, _g91, _path206, _path207, _g92, _path208, _path209, _g93, _path210, _path211, _g94, _path212, _path213, _g95, _path214, _path215, _g96, _path216, _path217, _g97, _path218, _path219, _g98, _path220, _path221, _g99, _path222, _path223, _g100, _path224, _path225, _g101, _path226, _path227, _g102, _path228, _path229, _g103, _path230, _path231, _g104, _path232, _path233, _g105, _path234, _path235, _g106, _path236, _path237, _g107, _path238, _path239, _g108, _path240, _path241, _g109, _path242, _path243, _g110, _path244, _path245, _g111, _path246, _path247, _g112, _path248, _path249, _g113, _path250, _path251, _g114, _path252, _path253, _g115, _path254, _path255, _g116, _path256, _path257, _g117, _path258, _path259, _g118, _path260, _path261, _g119, _path262, _path263, _g120, _path264, _path265, _g121, _path266, _path267, _g122, _path268, _path269, _g123, _path270, _path271, _g124, _path272, _path273, _g125, _path274, _path275, _g126, _path276, _path277, _g127, _path278, _path279, _g128, _path280, _path281, _g129, _path282, _path283, _g130, _path284, _path285, _g131, _path286, _path287, _g132, _path288, _path289, _g133, _path290, _path291, _g134, _path292, _path293, _g135, _path294, _path295, _g136, _path296, _path297, _g137, _path298, _path299, _g138, _path300, _path301, _g139, _path302, _path303, _g140, _path304, _path305, _g141, _path306, _path307, _g142, _path308, _path309, _g143, _path310, _path311, _g144, _path312, _path313, _g145, _path314, _path315, _g146, _path316, _path317, _g147, _path318, _path319, _g148, _path320, _path321, _g149, _path322, _path323, _g150, _path324, _path325, _g151, _path326, _path327, _g152, _path328, _path329, _g153, _path330;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogo2 = function SvgIconLogo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 61,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M23.125 0a20.5 20.5 0 0 0-8.464 3.035l5.061 1.249zM17.22 7.448l2.502-3.163-5.06-1.234z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M17.22 7.448 14.662 3.05l-1.043 5.106zM14.661 3.05a20.5 20.5 0 0 0-6.19 6.128l5.147-1.035zM12.903 11.717l.715-3.56L8.47 9.191zM19.722 4.284l3.403.85V0zM5.397 17.59h5.161l-.843-3.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M12.903 11.716 8.47 9.191l1.244 5.022z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M8.47 9.191a19.9 19.9 0 0 0-3.073 8.398l4.318-3.376zM19.722 4.285l-2.502 3.15a15.2 15.2 0 0 1 5.905-2.313zM17.22 7.445l-3.588.71-.73 3.56a15.4 15.4 0 0 1 4.319-4.27M12.903 11.715l-3.174 2.482.844 3.376a14.7 14.7 0 0 1 2.33-5.858M5.397 22.285a20.1 20.1 0 0 0 3.06 8.397l1.258-5.021z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M12.889 28.142 9.715 25.66l-1.258 5.021zM8.47 30.684a20.5 20.5 0 0 0 6.177 6.141l-1.044-5.106zM17.206 32.426l-3.588-.723 1.029 5.12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m9.715 25.661.843-3.376H5.397zM23.125 39.875v-5.121l-3.689.823z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m17.206 32.426-2.559 4.397 5.061-1.248zM14.647 36.824a20.5 20.5 0 0 0 8.478 3.05l-3.403-4.284zM9.715 25.661l3.174 2.482a14.96 14.96 0 0 1-2.33-5.858zM12.889 28.145l.715 3.56 3.588.723a15.6 15.6 0 0 1-4.303-4.283"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m17.206 32.426 2.502 3.149 3.417-.823a15.6 15.6 0 0 1-5.919-2.326M27.857 39.874a20.5 20.5 0 0 0 8.464-3.036L31.26 35.59zM33.762 32.426l-2.502 3.149 5.046 1.248zM33.762 32.424l2.545 4.397 1.043-5.106z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M36.306 36.823a20.5 20.5 0 0 0 6.19-6.128l-5.146 1.036z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m38.08 28.156-.73 3.56 5.147-1.02v-.015zM31.26 35.573l-3.403-.823v5.12zM45.57 22.285h-5.16l.843 3.66z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m38.08 28.157 4.417 2.524-1.244-5.02zM42.497 30.68a20.1 20.1 0 0 0 3.074-8.41l-4.318 3.375zM31.26 35.575l2.501-3.15a15.2 15.2 0 0 1-5.904 2.313zM33.762 32.441l3.588-.709.73-3.56a16 16 0 0 1-4.318 4.27"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m38.08 28.155 3.173-2.482-.843-3.376a15.1 15.1 0 0 1-2.33 5.858M45.571 17.589a20.1 20.1 0 0 0-3.06-8.398l-1.258 5.022z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m38.08 11.73 3.173 2.483 1.258-5.022z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m38.08 11.732 4.431-2.539-5.16-1.021zM42.511 9.193a20.5 20.5 0 0 0-6.176-6.142l1.044 5.106zM33.762 7.448l3.588.723-1.03-5.12zM41.253 14.21l-.843 3.377h5.16zM27.857 0v5.135l3.689-.837z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M33.762 7.448 36.32 3.05 31.26 4.299zM36.32 3.05A20.5 20.5 0 0 0 27.844 0l3.402 4.284zM41.253 14.213l-3.174-2.482a14.96 14.96 0 0 1 2.33 5.858zM38.08 11.729l-.716-3.56-3.588-.724a15.4 15.4 0 0 1 4.303 4.284"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m33.762 7.446-2.502-3.15-3.403.838a15.2 15.2 0 0 1 5.904 2.312M25.484 7.73l-3.603 6.185h7.22zM29.102 13.914l-3.618 6.199h7.206zM32.69 20.113 29.1 26.312h7.206zM21.882 26.312l3.602-6.199H18.28z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m29.102 26.312 3.588-6.199h-7.206zM25.484 20.113l3.617-6.199h-7.22zM18.279 20.113l-3.603 6.199h7.205z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m25.484 7.73-3.603 6.185h7.22zM29.102 13.914l-3.618 6.199h7.206zM32.69 20.113 29.1 26.312h7.206zM21.882 26.312l3.602-6.199H18.28z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "m29.102 26.312 3.588-6.199h-7.206zM25.484 20.113l3.617-6.199h-7.22zM18.279 20.113l-3.603 6.199h7.205zM12.888 28.14l.73 3.56-5.147-1.02zM4.947 52.609c0-.525-.172-.922-.486-1.178q-.473-.383-1.287-.383c-.4 0-.786.085-1.144.241a2.9 2.9 0 0 0-.9.596l-.744-.893a3.8 3.8 0 0 1 1.301-.78 4.8 4.8 0 0 1 1.644-.284q.772 0 1.33.213c.386.141.686.34.93.595.242.242.428.54.542.88s.172.709.172 1.092V55.8c0 .241.014.497.028.752s.043.482.086.652H5.133a4 4 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88s-.872.312-1.416.312c-.286 0-.571-.029-.872-.114a2.3 2.3 0 0 1-.829-.368 2.2 2.2 0 0 1-.629-.667C.071 55.956 0 55.616 0 55.204c0-.539.143-.964.443-1.29.3-.312.672-.553 1.144-.724s1.015-.27 1.601-.312c.6-.042 1.187-.07 1.787-.07zm-.343 1.22c-.358 0-.715.014-1.087.042-.386.029-.73.1-1.015.17a2.1 2.1 0 0 0-.758.398c-.2.17-.3.425-.3.723 0 .213.043.383.129.525q.128.213.343.34c.143.1.3.156.457.184.158.029.343.043.53.043.671 0 1.172-.198 1.529-.596.357-.383.529-.893.529-1.489V53.8h-.357zm6.39-6.27c0 .255-.1.468-.271.653a.94.94 0 0 1-.672.255.9.9 0 0 1-.658-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.172-.185.4-.256.658-.256.257 0 .486.086.672.256a.85.85 0 0 1 .271.638m-.229 9.645H9.35v-7.092h1.415zm4.704 0h-1.501V46.623h3.417c.515 0 1 .042 1.458.156.458.1.872.27 1.215.51.344.227.615.525.815.908s.3.823.3 1.362c0 .78-.242 1.404-.729 1.887-.486.482-1.1.78-1.858.907l2.974 4.866h-1.802l-2.716-4.71H15.44v4.71zm0-5.957h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525.128-.213.2-.482.2-.794s-.072-.596-.2-.795a1.7 1.7 0 0 0-.53-.524 2.1 2.1 0 0 0-.757-.27c-.3-.057-.6-.085-.915-.085h-1.83zm10.008-3.688c0 .255-.1.468-.272.653a.94.94 0 0 1-.672.255.93.93 0 0 1-.657-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.171-.185.4-.256.657-.256.258 0 .472.086.672.256a.85.85 0 0 1 .272.638m-.229 9.645h-1.415v-7.092h1.415zm3.703 1.206c.315.355.7.624 1.158.837s.944.312 1.43.312c.472 0 .872-.07 1.186-.198.315-.128.587-.313.772-.554.2-.24.33-.51.43-.822.085-.312.128-.667.128-1.036v-.908h-.029c-.257.398-.614.71-1.072.908a3.4 3.4 0 0 1-1.444.312c-.543 0-1.03-.1-1.487-.284a3.3 3.3 0 0 1-1.143-.78 3.6 3.6 0 0 1-.73-1.149 4 4 0 0 1-.257-1.418c0-.51.086-.993.257-1.433a3.6 3.6 0 0 1 .73-1.177 3.6 3.6 0 0 1 1.129-.794 3.6 3.6 0 0 1 1.473-.298c.514 0 1 .1 1.472.326.458.227.83.553 1.101 1.007h.029v-1.135h1.372v6.724c0 .525-.071 1.007-.2 1.49a3.2 3.2 0 0 1-.672 1.262c-.315.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.5 5.5 0 0 1-1.873-.34 4.8 4.8 0 0 1-1.616-.95zm.415-4.837c0 .327.043.653.157.936.1.298.257.568.457.795s.458.411.744.553c.3.142.629.213 1 .213.372 0 .701-.057 1.001-.199.3-.128.558-.312.772-.525.215-.227.386-.482.486-.794a2.8 2.8 0 0 0 .172-.979c0-.34-.057-.666-.172-.95a2.4 2.4 0 0 0-.5-.794 2.3 2.3 0 0 0-.772-.54 2.5 2.5 0 0 0-.986-.198c-.372 0-.7.07-1.001.198s-.543.313-.744.54-.371.482-.457.794a3 3 0 0 0-.157.95m10.322-2.383c.171-.354.457-.652.872-.893a2.7 2.7 0 0 1 1.387-.383c.457 0 .858.085 1.186.24.33.157.601.37.83.625s.386.567.486.908c.1.354.157.723.157 1.12v4.397h-1.415v-3.929c0-.297-.029-.567-.072-.822a2.1 2.1 0 0 0-.243-.695 1.3 1.3 0 0 0-.486-.483c-.2-.113-.472-.17-.8-.17-.558 0-1.016.213-1.387.638-.358.426-.544.993-.544 1.703v3.758h-1.415V45.871h1.415v5.29h.029zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.128 0 .271-.014.429-.029.157-.028.286-.07.4-.113l.043 1.149c-.172.057-.358.1-.572.142q-.3.042-.643.042-1.008 0-1.544-.553c-.358-.369-.53-.922-.53-1.66V51.29h-1.372v-1.163h1.373v-2.042h1.4v2.042h1.902z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__a",
    width: 51,
    height: 16,
    x: 0,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.947 52.609c0-.525-.172-.922-.486-1.178q-.473-.383-1.287-.383c-.4 0-.786.085-1.144.241a2.9 2.9 0 0 0-.9.596l-.744-.893a3.8 3.8 0 0 1 1.301-.78 4.8 4.8 0 0 1 1.644-.284q.772 0 1.33.213c.386.141.686.34.93.595.242.242.428.54.542.88s.172.709.172 1.092V55.8c0 .241.014.497.028.752s.043.482.086.652H5.133a4 4 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88s-.872.312-1.416.312c-.286 0-.571-.029-.872-.114a2.3 2.3 0 0 1-.829-.368 2.2 2.2 0 0 1-.629-.667C.071 55.956 0 55.616 0 55.204c0-.539.143-.964.443-1.29.3-.312.672-.553 1.144-.724s1.015-.27 1.601-.312c.6-.042 1.187-.07 1.787-.07zm-.343 1.22c-.358 0-.715.014-1.087.042-.386.029-.73.1-1.015.17a2.1 2.1 0 0 0-.758.398c-.2.17-.3.425-.3.723 0 .213.043.383.129.525q.128.213.343.34c.143.1.3.156.457.184.158.029.343.043.53.043.671 0 1.172-.198 1.529-.596.357-.383.529-.893.529-1.489V53.8h-.357zm6.39-6.27c0 .255-.1.468-.271.653a.94.94 0 0 1-.672.255.9.9 0 0 1-.658-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.172-.185.4-.256.658-.256.257 0 .486.086.672.256a.85.85 0 0 1 .271.638m-.229 9.645H9.35v-7.092h1.415zm4.704 0h-1.501V46.623h3.417c.515 0 1 .042 1.458.156.458.1.872.27 1.215.51.344.227.615.525.815.908s.3.823.3 1.362c0 .78-.242 1.404-.729 1.887-.486.482-1.1.78-1.858.907l2.974 4.866h-1.802l-2.716-4.71H15.44v4.71zm0-5.957h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525.128-.213.2-.482.2-.794s-.072-.596-.2-.795a1.7 1.7 0 0 0-.53-.524 2.1 2.1 0 0 0-.757-.27c-.3-.057-.6-.085-.915-.085h-1.83zm10.008-3.688c0 .255-.1.468-.272.653a.94.94 0 0 1-.672.255.93.93 0 0 1-.657-.255.82.82 0 0 1-.272-.639c0-.255.1-.468.272-.652.171-.185.4-.256.657-.256.258 0 .472.086.672.256a.85.85 0 0 1 .272.638m-.229 9.645h-1.415v-7.092h1.415zm3.703 1.206c.315.355.7.624 1.158.837s.944.312 1.43.312c.472 0 .872-.07 1.186-.198.315-.128.587-.313.772-.554.2-.24.33-.51.43-.822.085-.312.128-.667.128-1.036v-.908h-.029c-.257.398-.614.71-1.072.908a3.4 3.4 0 0 1-1.444.312c-.543 0-1.03-.1-1.487-.284a3.3 3.3 0 0 1-1.143-.78 3.6 3.6 0 0 1-.73-1.149 4 4 0 0 1-.257-1.418c0-.51.086-.993.257-1.433a3.6 3.6 0 0 1 .73-1.177 3.6 3.6 0 0 1 1.129-.794 3.6 3.6 0 0 1 1.473-.298c.514 0 1 .1 1.472.326.458.227.83.553 1.101 1.007h.029v-1.135h1.372v6.724c0 .525-.071 1.007-.2 1.49a3.2 3.2 0 0 1-.672 1.262c-.315.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.5 5.5 0 0 1-1.873-.34 4.8 4.8 0 0 1-1.616-.95zm.415-4.837c0 .327.043.653.157.936.1.298.257.568.457.795s.458.411.744.553c.3.142.629.213 1 .213.372 0 .701-.057 1.001-.199.3-.128.558-.312.772-.525.215-.227.386-.482.486-.794a2.8 2.8 0 0 0 .172-.979c0-.34-.057-.666-.172-.95a2.4 2.4 0 0 0-.5-.794 2.3 2.3 0 0 0-.772-.54 2.5 2.5 0 0 0-.986-.198c-.372 0-.7.07-1.001.198s-.543.313-.744.54-.371.482-.457.794a3 3 0 0 0-.157.95m10.322-2.383c.171-.354.457-.652.872-.893a2.7 2.7 0 0 1 1.387-.383c.457 0 .858.085 1.186.24.33.157.601.37.83.625s.386.567.486.908c.1.354.157.723.157 1.12v4.397h-1.415v-3.929c0-.297-.029-.567-.072-.822a2.1 2.1 0 0 0-.243-.695 1.3 1.3 0 0 0-.486-.483c-.2-.113-.472-.17-.8-.17-.558 0-1.016.213-1.387.638-.358.426-.544.993-.544 1.703v3.758h-1.415V45.871h1.415v5.29h.029zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.128 0 .271-.014.429-.029.157-.028.286-.07.4-.113l.043 1.149c-.172.057-.358.1-.572.142q-.3.042-.643.042-1.008 0-1.544-.553c-.358-.369-.53-.922-.53-1.66V51.29h-1.372v-1.163h1.373v-2.042h1.4v2.042h1.902z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__a)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__b",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M.3 45.871h-.329v14.936H.3z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__c",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M.643 45.871H.314v14.936h.33z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__d",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M.958 45.871h-.33v14.936h.33z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__e",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M1.286 45.871H.958v14.936h.328z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__f",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M1.615 45.871h-.328v14.936h.328z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__g",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M1.958 45.871H1.63v14.936h.33z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__h",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M2.287 45.871H1.96v14.936h.328z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__i",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M2.616 45.871h-.329v14.936h.329z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__j",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M2.93 45.871h-.328v14.936h.329z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__k",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M3.26 45.871h-.33v14.936h.33z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__l",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M3.603 45.871h-.33v14.936h.33z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__m",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M3.931 45.871h-.328v14.936h.328z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__n",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M4.26 45.871h-.328v14.936h.328z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__o",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M4.575 45.871h-.329v14.936h.329z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__p",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M4.918 45.871h-.33v14.936h.33z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__q",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M5.247 45.871h-.329v14.936h.329z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__r",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M5.575 45.871h-.328v14.936h.328z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__s",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M5.905 45.871h-.33v14.936h.33z"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__t",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M6.233 45.871h-.329v14.936h.33z"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__u",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M6.562 45.871h-.329v14.936h.33z"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__v",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M6.89 45.871h-.328v14.936h.329z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__w",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M7.22 45.871h-.33v14.936h.33z"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__x",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M7.549 45.871h-.33v14.936h.33z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__y",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M7.877 45.871h-.329v14.936h.33z"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__z",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M8.206 45.871h-.329v14.936h.33z"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__A",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M8.535 45.871h-.329v14.936h.329z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__B",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M8.864 45.871h-.329v14.936h.329z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__C",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M9.193 45.871h-.33v14.936h.33z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__D",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M9.522 45.871h-.33v14.936h.33z"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__E",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M9.864 45.871h-.328v14.936h.328z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__F",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M10.179 45.871H9.85v14.936h.329z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__G",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M10.508 45.871h-.329v14.936h.329z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__H",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M10.837 45.871h-.33v14.936h.33z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__I",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M11.18 45.871h-.329v14.936h.329z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__J",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M11.509 45.871h-.33v14.936h.33z"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__K",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M11.824 45.871h-.33v14.936h.33z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__L",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M12.152 45.871h-.329v14.936h.33z"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__M",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M12.48 45.871h-.328v14.936h.329z"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__N",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M12.824 45.871h-.329v14.936h.329z"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__O",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M13.153 45.871h-.329v14.936h.329z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__P",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M13.482 45.871h-.33v14.936h.33z"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__Q",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M13.796 45.871h-.329v14.936h.33z"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__R",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M14.14 45.871h-.33v14.936h.33z"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__S",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M14.468 45.871h-.329v14.936h.329z"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__T",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M14.797 45.871h-.329v14.936h.33z"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__U",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M15.126 45.871h-.33v14.936h.33z"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__V",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M15.44 45.871h-.329v14.936h.33z"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__W",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M15.783 45.871h-.328v14.936h.328z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__X",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M16.113 45.871h-.33v14.936h.33z"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__Y",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M16.441 45.871h-.329v14.936h.33z"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__Z",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M16.77 45.871h-.33v14.936h.33z"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aa",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M17.099 45.871h-.329v14.936h.329z"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ab",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M17.428 45.871h-.33v14.936h.33z"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ac",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M17.757 45.871h-.33v14.936h.33z"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ad",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M18.085 45.871h-.329v14.936h.33z"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ae",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M18.414 45.871h-.329v14.936h.33z"
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__af",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M18.743 45.871h-.329v14.936h.329z"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ag",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M19.072 45.871h-.33v14.936h.33z"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ah",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M19.4 45.871h-.328v14.936h.329z"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ai",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M19.73 45.871h-.33v14.936h.33z"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aj",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M20.058 45.871h-.328v14.936h.328z"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ak",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M20.402 45.871h-.33v14.936h.33z"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__al",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__al)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M20.73 45.871h-.329v14.936h.33z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__am",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M21.045 45.871h-.33v14.936h.33z"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__an",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M21.374 45.871h-.33v14.936h.33z"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ao",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M21.702 45.871h-.329v14.936h.33z"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ap",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ap)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M22.046 45.871h-.33v14.936h.33z"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aq",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M22.374 45.871h-.329v14.936h.33z"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ar",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M22.689 45.871h-.33v14.936h.33z"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__as",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M23.018 45.871h-.329v14.936h.329z"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__at",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M23.36 45.871h-.328v14.936h.329z"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__au",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__au)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M23.69 45.871h-.33v14.936h.33z"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__av",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__av)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M24.018 45.871h-.329v14.936h.33z"
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aw",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M24.347 45.871h-.328v14.936h.328z"
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ax",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ax)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M24.662 45.871h-.329v14.936h.329z"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ay",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ay)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M25.005 45.871h-.329v14.936h.33z"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__az",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M25.334 45.871h-.33v14.936h.33z"
  }))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aA",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M25.663 45.871h-.329v14.936h.329z"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aB",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M25.991 45.871h-.328v14.936h.328z"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aC",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M26.32 45.871h-.329v14.936h.329z"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aD",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M26.65 45.871h-.33v14.936h.33z"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aE",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M26.978 45.871h-.33v14.936h.33z"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aF",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M27.307 45.871h-.329v14.936h.329z"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aG",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M27.636 45.871h-.33v14.936h.33z"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aH",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M27.965 45.871h-.33v14.936h.33z"
  }))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aI",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M28.293 45.871h-.329v14.936h.33z"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aJ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M28.622 45.871h-.329v14.936h.329z"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aK",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M28.95 45.871h-.328v14.936h.329z"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aL",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M29.28 45.871h-.33v14.936h.33z"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aM",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M29.623 45.871h-.33v14.936h.33z"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aN",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M29.951 45.871h-.328v14.936h.328z"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aO",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M30.266 45.871h-.328v14.936h.328z"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aP",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M30.595 45.871h-.329v14.936h.329z"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aQ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M30.924 45.871h-.33v14.936h.33z"
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aR",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M31.267 45.871h-.329v14.936h.329z"
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aS",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M31.596 45.871h-.329v14.936h.329z"
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aT",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M31.91 45.871h-.329v14.936h.33z"
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aU",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M32.239 45.871h-.329v14.936h.329z"
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aV",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M32.568 45.871h-.329v14.936h.33z"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aW",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M32.91 45.871h-.328v14.936h.329z"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aX",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M33.24 45.871h-.329v14.936h.329z"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aY",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M33.569 45.871h-.33v14.936h.33z"
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__aZ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M33.883 45.871h-.329v14.936h.329z"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__ba",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M34.226 45.871h-.328v14.936h.328z"
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bb",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M34.555 45.871h-.328v14.936h.328z"
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bc",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M34.884 45.871h-.329v14.936h.329z"
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bd",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M35.213 45.871h-.33v14.936h.33z"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__be",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M35.528 45.871h-.33v14.936h.33z"
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bf",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M35.87 45.871h-.328v14.936h.328z"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bg",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M36.2 45.871h-.33v14.936h.33z"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bh",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M36.528 45.871h-.329v14.936h.329z"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bi",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bi)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M36.857 45.871h-.329v14.936h.33z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bj",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M37.186 45.871h-.33v14.936h.33z"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bk",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M37.515 45.871h-.329v14.936h.329z"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bl",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M37.844 45.871h-.33v14.936h.33z"
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bm",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M38.172 45.871h-.329v14.936h.33z"
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bn",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M38.501 45.871h-.329v14.936h.33z"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bo",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M38.83 45.871H38.5v14.936h.329z"
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bp",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M39.159 45.871h-.329v14.936h.329z"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bq",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M39.488 45.871h-.33v14.936h.33z"
  }))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__br",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__br)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M39.817 45.871h-.33v14.936h.33z"
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bs",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M40.145 45.871h-.329v14.936h.33z"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bt",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M40.489 45.871h-.33v14.936h.33z"
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bu",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M40.817 45.871h-.329v14.936h.33z"
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bv",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M41.132 45.871h-.33v14.936h.33z"
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bw",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M41.46 45.871h-.328v14.936h.329z"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bx",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M41.79 45.871h-.33v14.936h.33z"
  }))), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__by",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__by)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M42.133 45.871h-.33v14.936h.33z"
  }))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bz",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M42.461 45.871h-.329v14.936h.33z"
  }))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bA",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M42.776 45.871h-.329v14.936h.33z"
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bB",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M43.105 45.871h-.33v14.936h.33z"
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bC",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M43.448 45.871h-.329v14.936h.329z"
  }))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bD",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M43.777 45.871h-.33v14.936h.33z"
  }))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bE",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M44.106 45.871h-.33v14.936h.33z"
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bF",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M44.434 45.871h-.328v14.936h.328z"
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bG",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M44.749 45.871h-.33v14.936h.33z"
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bH",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M45.092 45.871h-.329v14.936h.329z"
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bI",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M45.42 45.871h-.328v14.936h.329z"
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bJ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M45.75 45.871h-.33v14.936h.33z"
  }))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bK",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M46.078 45.871h-.329v14.936h.33z"
  }))), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bL",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M46.407 45.871h-.328v14.936h.328z"
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bM",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M46.736 45.871h-.329v14.936h.33z"
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bN",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M47.065 45.871h-.33v14.936h.33z"
  }))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bO",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M47.394 45.871h-.33v14.936h.33z"
  }))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bP",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M47.722 45.871h-.328v14.936h.328z"
  }))), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bQ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M48.052 45.871h-.33v14.936h.33z"
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bR",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M48.38 45.871h-.329v14.936h.33z"
  }))), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bS",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M48.71 45.871h-.33v14.936h.33z"
  }))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bT",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M49.038 45.871h-.329v14.936h.329z"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bU",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M49.367 45.871h-.329v14.936h.329z"
  }))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bV",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M49.71 45.871h-.33v14.936h.33z"
  }))), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bW",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M50.039 45.871h-.329v14.936h.329z"
  }))), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bX",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M50.353 45.871h-.329v14.936h.33z"
  }))), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bY",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M50.682 45.871h-.329v14.936h.329z"
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-logo-2_svg__bZ",
    width: 53,
    height: 16,
    x: -1,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-logo-2_svg__bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.011 45.871h-.329v14.936h.329z"
  }))), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M51.01 45.871H-.028v14.936h51.04z"
  }))));
};
export default SvgIconLogo2;